module.exports = __webpack_public_path__ + "static/media/logo138x75black.a446748a.png";